let semanticUiStylesPromise = null

export function ensureSemanticUiStyles() {
    if (!semanticUiStylesPromise) {
        semanticUiStylesPromise = Promise.all([
            import('semantic-ui-css/semantic.min.css'),
            import('@styles/semantic-ui-font-override.css'),
        ]).catch((error) => {
            semanticUiStylesPromise = null
            throw error
        })
    }

    return semanticUiStylesPromise
}
